import { Eye, Save } from "lucide-react";

export default function LegalTextEditor({ title, html, onTitleChange, onHtmlChange, onSave, saving, sanitizedPreview }) {
  return (
    <div className="grid gap-5 xl:grid-cols-2">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <label className="text-sm font-medium text-slate-700">Titel
          <input value={title} onChange={(event) => onTitleChange(event.target.value)} className="input-admin" />
        </label>
        <label className="mt-4 block text-sm font-medium text-slate-700">Vertragstext als bereinigtes HTML
          <textarea value={html} onChange={(event) => onHtmlChange(event.target.value)} rows={22} className="mt-2 w-full rounded-xl border border-slate-300 bg-slate-950 p-4 font-mono text-xs leading-6 text-slate-100" />
        </label>
        <p className="mt-2 text-xs leading-5 text-slate-500">Erlaubt sind Überschriften, Absätze, Listen, Hervorhebungen, Links und Tabellen. Skripte, Styles und Event-Handler entfernt der Server.</p>
        <button onClick={onSave} disabled={saving || !title.trim() || !html.trim()} className="mt-4 inline-flex items-center gap-2 rounded-xl bg-slate-950 px-4 py-2.5 text-sm font-semibold text-white disabled:bg-slate-300"><Save className="h-4 w-4" />{saving ? "Speichert …" : "Entwurf speichern"}</button>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="mb-4 flex items-center gap-2 text-sm font-semibold text-slate-900"><Eye className="h-4 w-4 text-red-700" />Serverbereinigte Vorschau</div>
        {sanitizedPreview ? <div className="contract-legal rounded-xl border border-slate-200 p-5" dangerouslySetInnerHTML={{ __html: sanitizedPreview }} /> : <div className="rounded-xl bg-slate-50 p-8 text-center text-sm text-slate-500">Entwurf speichern, um die bereinigte Vorschau zu sehen.</div>}
      </div>
    </div>
  );
}

